import Circle from "../LogoSVG/Circle";
import Arrow from "../LogoSVG/Arrow";

function NetcompanyMobile({ className }: any) {
  return (
    <a className="" href="https://netcompany.com/" target="_blank">
      <div className=" text-gray-4 mb-2 text-[15px]">Jul 2024 - Jul 2025</div>

      <a
        className="block text-[16px] font-medium mb-2"
        href="https://netcompany.com/"
        target="_blank"
      >
        Software Engineer
        <Circle className="mx-1.5 h-1 w-1 inline align-middle" />
        Netcompany Group{" "}
        <span className="whitespace-nowrap">
          A/S <Arrow className="inline align-middle ml-2" />
        </span>
      </a>

      <div className=" text-gray-5 text-[16px] mb-12">
        <div className="flex flex-row items-start mb-2">
          <span>
            <Circle className="mr-3 h-1.5 w-1.5 mt-2" />
          </span>
          <div className="text-gray-4 ">
            Optimized ElasticSearch indexing service for FIFA’s products
            (FIFACom/ FIFA Mediahub/ InsideFIFA) via sitemaps and webhooks
          </div>
        </div>

        <div className="flex flex-row items-start mb-2">
          <span>
            <Circle className="mr-3 h-1.5 w-1.5 mt-2" />
          </span>
          <div className="text-gray-4 ">
            Improved search API for FIFA websites, handling nearly 8M monthly
            requests and mitigating up to 100K monthly failed requests during
            FCWC
          </div>
        </div>

        <div className="flex flex-row items-start mb-2">
          <span>
            <Circle className="mr-3 h-1.5 w-1.5 mt-2" />
          </span>
          <div className="text-gray-4 ">
            Built and maintained custom CMS Contentful application services,
            CI/CD pipelines to help FIFA editors publish content
          </div>
        </div>
      </div>
    </a>
  );
}

export default NetcompanyMobile;
